"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Leaf } from "lucide-react";
export default function UnderstandingDana() {
  const {
    ref: bgRef,
    isVisible: bgVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: leafRef,
    isVisible: leafVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: iconRef,
    isVisible: iconVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative w-full overflow-hidden bg-background py-20">
      {}
      <div ref={bgRef} className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-smooth" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/sunrise_forest_clearing.png)",
      opacity: bgVisible ? 1 : 0
    }} />

      {}
      <div className="relative z-10 mx-auto max-w-5xl px-6">
        <div ref={leafRef} className="group relative overflow-hidden rounded-2xl bg-background/10 p-12 shadow-strong backdrop-blur-md transition-all duration-slow ease-out-back hover:shadow-[0_12px_40px_rgba(140,100,60,0.3)]" style={{
        transform: leafVisible ? "translateY(0)" : "translateY(3rem)",
        opacity: leafVisible ? 1 : 0
      }}>
          {}
          <div ref={iconRef} className="absolute left-4 top-1/2 -translate-y-1/2 transition-opacity duration-300 ease-smooth" style={{
          opacity: iconVisible ? 1 : 0
        }}>
            <Leaf className="h-8 w-8 text-primary" strokeWidth={1.5} />
          </div>

          {}
          <div className="ml-12 space-y-6">
            <h2 className="font-display text-4xl font-semibold text-foreground">
              Understanding Dana
            </h2>
            <p className="max-w-2xl text-lg leading-relaxed text-foreground/80">
              Dana, the practice of generosity, is an ancient tradition. All
              offerings are freely given. Your generosity sustains this path for
              yourself and others, creating a circle of goodness and mutual
              support.
            </p>
            <p className="max-w-2xl text-base leading-relaxed text-foreground/70">
              We invite you to give as your heart moves you, knowing that every
              gift — whether large or small — is received with deep gratitude
              and used to nurture the Dharma community.
            </p>
          </div>
        </div>
      </div>
    </section>;
}